import React, { useEffect, useState } from 'react';

import ShowUpPlan from './ShowUpPlan';

import styles from './styles.module.css';

const HighligthPlans = ({ plans, providers, match, mobile, selectedPlans, addComparisonPlan, removeComparisonPlan, variant }) => {
  if (plans && plans.length < 3) return null;

  const [orderedPlans, setOrderedPlans] = useState(plansOrdenation(plans, mobile));

  useEffect(() => {
    setOrderedPlans(plansOrdenation(plans, mobile));
  }, [plans, mobile]);

  const isV2 = (variant || '').toString().toUpperCase() === 'V2';
  const getProviderImgPath = (providerCode) => {
    const providerSlug = providers.filter((provider) => provider.code === providerCode)[0];
    const providerImgPath = providerSlug ? `/assets/images/seguradoras/${providerSlug.slug}.png` : '';

    return providerImgPath;
  };

  const basePath =  '/seguro-viagem/cobertura';

  return (
    <section
      className={`${isV2 ? styles.wrapperV2 : 'highlight-plans-wrapper'}`}
      data-variant={isV2 ? 'V2' : 'V1'}
    >
      {!isV2 && <h2>Encontre os melhores planos para sua viagem!</h2>}

      <div className={`${isV2 ? styles.carouselV2 : 'carroussel scroll-component scroll-component-v1'}`}>
        {orderedPlans.map((plan) => (
          <ShowUpPlan
            key={plan.code}
            plan={plan}
            basePath={basePath}
            match={match}
            isSelected={selectedPlans.includes(plan.code)}
            providerImgPath={getProviderImgPath(plan.provider_code)}
            addComparisonPlan={addComparisonPlan}
            removeComparisonPlan={removeComparisonPlan}
            variant={variant}
          />
        ))}
      </div>
    </section>
  );
};

function plansOrdenation(plans, mobile) {
  if (mobile) {
    return [...plans].sort((a, b) => a.priority - b.priority);
  } else {
    const desktopOrder = [1, 0, 2];
    return [...plans].sort((a, b) => desktopOrder.indexOf(a.priority) - desktopOrder.indexOf(b.priority));
  }
}

export default HighligthPlans;



// WEBPACK FOOTER //
// ./src/components/search/plans_table/HighligthPlans/index.jsx